import React, { useEffect } from "react";
import "./Unsubscribe.scss";
import axios from "../../../utils/axios";

import { useNavigate } from "react-router";
import BaseDialog from "../../../modelDialogs/BaseDialog";
import { itx } from "../../../translationItx/itx";

export default function Unsubscribe() {
  const queryParameters = new URLSearchParams(window.location.search);
  const email = queryParameters.get("email");
  const navigate = useNavigate();

  useEffect(() => {
    state._navigate = navigate;
  }, []);

  useEffect(() => {
    if (email) {
      axios
        .post(`/api/unsubscribeUser/${email}`, {})
        .then((result: any) => {
          state.dialogManager.openDialog(
            <BaseDialog
              title={state.translate("Success", "Success")}
              onOk={() => {
                state.navigate("/login");
                return true;
              }}
              okCaption={state.translate("ok", "Ok")}
              noAbortButton={true}
            >
              <div style={{ padding: "20px" }}>
                {itx("Unsubscribe.youhavebeen", "You have been unsubscribed from the newsletter!")}
                {/* {state.translate(
                  "verifyeEmail.emailVerified",
                  "You have been unsubscribed from the newsletter!",
                )} */}
              </div>
            </BaseDialog>,
          );

          if (result.data.DATA.token) {
            state.navigate("/login");
          }
        })
        .catch((e) => {
          if (e.STATUS === "FAILURE") {
            state.dialogManager.openDialog(
              <BaseDialog
                title={state.translate("error", "Error")}
                onOk={() => {
                  state.navigate("/login");
                  return true;
                }}
                okCaption={state.translate("ok", "Ok")}
                noAbortButton={true}
              >
                <div style={{ padding: "20px" }}>
                  {state.translate("setPassword.tokenExpired", "Token Expired. Please Try Again.")}
                </div>
              </BaseDialog>,
            );
          }
        });
    } else {
      state.dialogManager.openDialog(
        <BaseDialog
          title={state.translate("error", "Error")}
          onOk={() => {
            return true;
          }}
          okCaption={state.translate("ok", "Ok")}
          noAbortButton={true}
        >
          <div style={{ padding: "20px" }}>
            {state.translate("setPassword.somthingWentwrong", "Something Went Wrong. Please Try Again.")}
          </div>
        </BaseDialog>,
      );
    }
  });

  return (
    <div className="Login">
      <div className="lView"></div>
      <div className="rView">
        <img
          src="/images/auth/rView.png" // no itx
          alt=""
        />
      </div>
      {/* <DialogHost /> */}
    </div>
  );
}
